import { normalizeHref } from "./../link/normalize-href";
import { uuid } from "./../../wix-rich-content-common";
const convertToGalleryItem = (item, index, relValue, anchorTarget) => {
  const { image, video, title, altText } = item;
  const media = image?.media || video?.media;
  const mediaUrl = media?.src?.url || media?.src?.id || "";
  const width = media?.width || 0;
  const height = media?.height || 0;
  const convertedData = {
    mediaUrl,
    url: mediaUrl,
    metaData: {
      type: image ? "image" : "video",
      height,
      width,
      title,
      alt: altText
    },
    // uuid is used to guarentee there are no 2 gallery items on the DOM with the same ID (on different galleries) due to a pro gallery issues with videos - breaks the video controls behavoiur.
    itemId: uuid() + "_" + index.toString(),
    hash: mediaUrl + "_" + index.toString()
  };
  if (video) {
    convertedData.metaData.link = {
      target: "_blank",
      rel: "noopener",
      url: normalizeHref(mediaUrl) ?? ""
    };
    const { src, width: thumbnailWidth, height: thumbnailHeight } = video.thumbnail || {};
    if (src?.url) {
      convertedData.metaData.poster = {
        url: src.url,
        width: thumbnailWidth || width,
        height: thumbnailHeight || height
      };
    }
  }
  if (image?.link) {
    const { url: linkUrl = "", target: linkTarget, rel: linkRel } = image.link;
    const target = linkTarget && `_${linkTarget.toLowerCase()}` || anchorTarget || "_self";
    const url = normalizeHref(linkUrl) ?? "";
    let rel = relValue || "noopener";
    if (linkRel) {
      rel = "noopener";
      linkRel.nofollow && (rel += " nofollow");
      linkRel.sponsored && (rel += " sponsored");
      linkRel.ugc && (rel += " ugc");
      (linkRel.noreferrer || linkRel.noreferrer === void 0) && (rel += " noreferrer");
    }
    convertedData.metaData.link = {
      type: "wix",
      target,
      data: {
        type: "ExternalLink",
        target,
        rel,
        url
      }
    };
    convertedData.directLink = {
      url,
      target,
      rel
    };
  }
  return convertedData;
};
export {
  convertToGalleryItem
};
//# sourceMappingURL=convert-to-gallery-item.js.map
